
















































































































































import Vue from 'vue'
import firebase from 'firebase/compat/app'
import { Location, OAuth2 } from '@/models'
import config from '@/config'
import { trackGaEvent } from '@/util/helper'
import GmbIcon from '@/assets/pmd/img/gmb.svg'
// import AlertTriangleIcon from '@/assets/pmd/img/launchpad/alert-triangle.svg'
import GoogleMyBusinessMakePrimaryModal from './GoogleMyBusinessMakePrimaryModal.vue'
import GoogleMyBusinessNoGmbPageModal from './GoogleMyBusinessNoGmbPageModal.vue'
import { IntegrationService } from '@/services'
import { UxMessage } from '@/util/ux_message'

declare var $: any
let openedWindow: Window | null
let cancelGoogleSubscription: () => void

// Create IE + others compatible event handler
const eventMethod: string = window.addEventListener
  ? 'addEventListener'
  : 'attachEvent'
const win: any = window
const eventer = win[eventMethod]
const messageEvent = eventMethod == 'attachEvent' ? 'onmessage' : 'message'

// Listen to message from child window
eventer(
  messageEvent,
  function (e) {
    if (e.data && e.data.page === 'integrations_settings') {
      if (e.data.actionType === 'close' && openedWindow) {
        openedWindow.close()
      }
    }
  },
  false
)

export default Vue.extend({
  inject: ['uxmessage'],
  props: ['currentLocationId', 'userid'],
  components: {
    GmbIcon,
    // AlertTriangleIcon,
    GoogleMyBusinessMakePrimaryModal,
    GoogleMyBusinessNoGmbPageModal,
  },
  data() {
    return {
      googleLocations: [] as any,
      analyticsAccounts: [] as any,
      googleBusinessAccount: '',
      analyticsAcc: '',
      slideShow: false,
      sending: false,
      location: {} as Location,
      gmbAuth: false,
      googleConnections: [] as OAuth2[],
      connectLoader: false,
      disableHandler: {
        action: 'google',
        disable: false,
      },
      processing: false,
      noGmbAccount: false,
      makePrimaryAccount: false,
      makeGoogleConnectionPrimary: {} as OAuth2,
    }
  },
  watch: {
    '$route.params.location_id': async function (id) {
      this.location = new Location(
        await this.$store.dispatch('locations/getCurrentLocation', id)
      )
      if (!this.isGMBConnected) {
        this.processing = true
        try {
          await this.fetchGoogleData()
        } catch (err) {}
        this.processing = false
      }
      if (this.googleLocations.length > 0 && !this.location.gmb.name) {
        this.gmbAuth = true
      }
    },
  },
  computed: {
    isGMBConnected(): boolean | undefined {
      return this.location.gmb?.name && this.googleConnections.length ? true : false
    },
    btnText(): string {
      let btnTxt = 'Connect'
      if (this.reconnect) {
        btnTxt = 'Reconnect'
      }
      return this.connectLoader ? 'Connecting...' : btnTxt
    },
    reconnect(): boolean {
      return this.location.isGmbDisconnected
    },
    disableButton(): string {
      return this.slideShow ? 'pointer-events:none !important' : ''
    },
  },
  async mounted() {
    this.location = new Location(
      await this.$store.dispatch(
        'locations/getCurrentLocation',
        this.currentLocationId
      )
    )
    const $selectpicker = $(this.$el).find('.selectpicker')
    if ($selectpicker) {
      $selectpicker.selectpicker('refresh')
    }
    if (!this.isGMBConnected) {
      this.processing = true
      try {
        await this.fetchGoogleData()
      } catch (err) {}
      this.processing = false
    }
    if (this.googleLocations.length > 0 && !this.location.gmb.name) {
      this.gmbAuth = true
    }
    this.$root.$on('close-nogmb-modal', () => {
      this.noGmbAccount = false
    })
    this.$root.$on('google-connect', () => {
      this.connectGoogle()
    })
    this.$root.$on('close-modal', async () => {
      try {
        this.disableHandler.disable = false
        this.$root.$emit(
          'disable-launchpad-action',
          JSON.stringify(this.disableHandler)
        )
        await this.location.ref.update({
          recent_google_connection_id: firebase.firestore.FieldValue.delete(),
        })
        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
        this.makePrimaryAccount = false
        this.noGmbAccount = false
        await this.fetchGoogleData()
      } catch (err) {}
    })
    this.$root.$on('gmb-primary-change', async () => {
      this.makePrimaryAccount = false
      this.noGmbAccount = false
      this.location = new Location(
        await this.$store.dispatch(
          'locations/getCurrentLocation',
          this.currentLocationId
        )
      )
      this.processing = true
      try {
        await this.fetchGoogleData()
        if (
          (this.googleLocations.length > 1 || this.analyticsAccounts > 1) &&
          !this.isGMBConnected
        ) {
          this.slideShow = true
          this.gmbAuth = true
        } else {
          this.disableHandler.disable = false
          this.$root.$emit(
            'disable-launchpad-action',
            JSON.stringify(this.disableHandler)
          )
        }
      } catch (err) {
        this.disableHandler.disable = false
        this.$root.$emit(
          'disable-launchpad-action',
          JSON.stringify(this.disableHandler)
        )
      }
      this.processing = false
    })
  },
  updated() {
    const $selectpicker = $(this.$el).find('.selectpicker')
    if ($selectpicker) {
      $selectpicker.selectpicker('refresh')
      if (
        this.company &&
        this.company.country == 'US' &&
        this.$refs.stateSelect
      ) {
        $(this.$refs.stateSelect).selectpicker('val', this.company.state)
      }
    }
  },
  methods: {
    fetchGoogleData(connect?: boolean) {
      return new Promise((resolve, reject) => {
        try {
          this.analyticsAccounts = []

          if (cancelGoogleSubscription) {
            cancelGoogleSubscription()
          }
          cancelGoogleSubscription = OAuth2.getAllByLocationIdAndType(
            this.currentLocationId,
            OAuth2.TYPE_GOOGLE
          ).onSnapshot(async (snapshot: firebase.firestore.QuerySnapshot) => {
            this.googleConnections = snapshot.docs.map(
              (d: firebase.firestore.QueryDocumentSnapshot) => new OAuth2(d)
            )
            let googleAccountId = this.location.primaryGoogleConnectionId
            if (connect && this.location.recentGoogleConnectionId) {
              googleAccountId = this.location.recentGoogleConnectionId
            }
            let googleConnection = this.googleConnections.find(
              x => x.id === googleAccountId
            )

            if (googleConnection) {
              try {
                let data = await IntegrationService.GMB.getAccountsLocations(this.currentLocationId, true)
                this.googleLocations = data.locations.map(location => {
                  location.locationName = location.title || ""
                  location.name = location.accountName + '/' + location.name || ""
                  location.address = location.storefrontAddress || ""
                  location.locationState = { isVerified : true }
                  location.locationKey = { placeId: location.metadata?.placeId || "" }
                  return location
                })
                if (!this.googleLocations.length && connect) {
                  this.noGmbAccount = true
                }
                if (
                  this.googleLocations.length &&
                  connect &&
                  googleAccountId !== this.location.primaryGoogleConnectionId
                ) {
                  this.noGmbAccount = false
                  this.makePrimaryAccount = true
                  this.makeGoogleConnectionPrimary = googleConnection
                }
              } catch (err) {
                console.log(err)
              }

              try {
                let { data } = await this.$http.get(
                  '/google/get_analytics_accounts',
                  {
                    params: {
                      oauth_id: googleConnection.id,
                    },
                  }
                )
                this.analyticsAccounts = data.data['items']
              } catch (err) {
                this.analyticsAccounts = []
              }
              if (this.googleLocations.length == 1)
                this.googleBusinessAccount = this.googleLocations[0]
              if (this.analyticsAccounts.length == 1) {
                this.analyticsAcc = this.analyticsAccounts[0].id
              }
              if (
                this.googleLocations.length == 1 &&
                this.analyticsAccounts.length <= 1 &&
                !this.isGMBConnected
              ) {
                this.disableHandler.disable = true
                this.$root.$emit(
                  'disable-launchpad-action',
                  JSON.stringify(this.disableHandler)
                )
                await this.linkBusinessPage()
              }
            }
            resolve(true)
          }, (err) => {
            console.error(err)
            throw err
          })
        } catch (error) {
          reject(error)
        }
      })
    },
    connectGoogle() {
      trackGaEvent(
        'Launchpad',
        'Initiate GMB connect',
        `Init GMB connect for location: ${this.currentLocationId}`
      )
      this.disableHandler.disable = true
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.connectLoader = true
      this.noGmbAccount = false
      this.makePrimaryAccount = false
      openedWindow = window.open(
        `${config.baseUrl}/api/gmail/start_oauth?location_id=${this.currentLocationId}&user_id=${this.userid}&launchpad=true`,
        'MyWindow',
        'toolbar=no, menubar=no,scrollbars=no,resizable=no,location=no,directories=no,status=no'
      )
      const timer = setInterval(async () => {
        if (openedWindow.closed) {
          clearInterval(timer)
          try {
            this.location = new Location(
              await this.$store.dispatch(
                'locations/getCurrentLocation',
                this.currentLocationId
              )
            )
            await this.fetchGoogleData(true)
          } catch (err) {
            // console.log(err)
          }
          this.connectLoader = false
          if (
            (this.googleLocations.length > 1 || this.analyticsAccounts > 1) &&
            !this.isGMBConnected &&
            !this.makePrimaryAccount
          ) {
            this.slideShow = true
            this.gmbAuth = true
          } else if (!this.googleLocations.length && !this.makePrimaryAccount) {
            this.disableHandler.disable = false
            this.$root.$emit(
              'disable-launchpad-action',
              JSON.stringify(this.disableHandler)
            )
          }
        }
      }, 500)
    },
    async linkBusinessPage() {
      if (this.sending) return
      this.sending = true
      let error = false
      if (!this.googleBusinessAccount) {
        this.$validator.errors.add({
          field: 'googleBusinessAccount',
          msg: 'Business required.',
        })
        error = true
      }

      if (error) {
        this.sending = false
        return false
      }

      try {
        let name = this.googleBusinessAccount.locationName
        if (this.googleBusinessAccount.address) {
          name += ' - '
          if (this.googleBusinessAccount.address.locality)
            name += this.googleBusinessAccount.address.locality
          if (
            this.googleBusinessAccount.address.locality &&
            this.googleBusinessAccount.address.administrativeArea
          )
            name += ', '
          if (this.googleBusinessAccount.address.administrativeArea)
            name += this.googleBusinessAccount.address.administrativeArea
        }
        const data = await IntegrationService.GMB.connect({
          locationId: this.currentLocationId,
          gmbLocationId: this.googleBusinessAccount.name,
          gmbLocationName: name,
          gmbPlacesId: this.googleBusinessAccount.locationKey.placeId,
          gmbLocationOnlyName: this.googleBusinessAccount.locationName,
          isVerified: this.googleBusinessAccount.locationState.isVerified,
          enableCallTracking: false,
          launchpad: true,
        })
        const location = await Location.getById(this.currentLocationId)
        location.isGmbDisconnected = false
        if (this.analyticsAcc)
          location.googleAnalyticsAccountId = this.analyticsAcc

        if (location.deleted === undefined) {
          trackGaEvent(
            'Error',
            'Location save issue on gmb launchpad',
            location.id,
            1
          )
        }

        const updatedData = {
          is_gmb_disconnected: false,
          // google_analytics_account_id: this.analyticsAcc,
          date_updated: firebase.firestore.FieldValue.serverTimestamp(),
          last_updated_by: {
            source: 'gmb',
            channel: 'web_app',
          },
        } as any

        if (this.analyticsAcc) {
          updatedData.google_analytics_account_id = this.analyticsAcc
        }

        await location.ref.update(updatedData)

        this.location = new Location(
          await this.$store.dispatch(
            'locations/getCurrentLocation',
            this.currentLocationId
          )
        )
        trackGaEvent(
          'Launchpad',
          'Successfully GMB connected',
          `Successfully GMB connected for location: ${this.currentLocationId}`
        )
        this.$root.$emit('launchpad-status')
      } catch (err) {
        console.error(err)
        this.uxmessage(UxMessage.errorType('', err?.response?.data || err.message || 'Something went wrong while connecting GMB'), true)
      }
      this.sending = false
      this.disableHandler.disable = false
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.slideShow = false
    },
    connectPage() {
      this.disableHandler.disable = !this.disableHandler.disable
      this.$root.$emit(
        'disable-launchpad-action',
        JSON.stringify(this.disableHandler)
      )
      this.slideShow = !this.slideShow
    },
    perfromAction() {
      if (this.isGMBConnected) {
        return false
      } else if (this.gmbAuth) {
        this.connectPage()
      } else if (!this.gmbAuth) {
        this.connectGoogle()
      }
    },
  },
})
